import React, { useEffect, useState } from 'react';
import { scrollToTop } from '../utils';
import GarantiaGloomisMX from '../components/Garantia/GarantiaGLoomisMX';
import GarantiaGloomisUS from '../components/Garantia/GarantiaGLoomisUS';
import { useLanguage } from '../LanguageContext';

const GarantiaGloomis = () => {
    const [filialSelecionada, setFilialSelecionada] = useState('');

    useEffect(() => {
        scrollToTop();

        // Captura o valor do cookie _filialSelecionada
        const cookies = document.cookie.split('; ');
        const filialCookie = cookies.find(row => row.startsWith('_filialSelecionada='));
        if (filialCookie) {
            setFilialSelecionada(filialCookie.split('=')[1]);
        }
    }, []);

    const { translations, changeLanguage, language } = useLanguage();

    return (
        <>
            {language === 'es-MX'  ?  <GarantiaGloomisMX /> : <GarantiaGloomisUS />}
        </>
    );
}

export default GarantiaGloomis;